enum CurvaABC {
    A = 1,
    B = 2,
    C = 3,
}

export default CurvaABC;
